<template lang="pug">
  v-row
    v-col(cols="12")
      v-alert(type="info" text).
        Здесь вы можете предлагать лицензии на созданные вами курсы другим педагогам/организациям,
        а также получить права на готовые курсы, созданные другими талантливыми специалистами

      .d-flex.align-center
        h1 {{ title }}
        v-btn(
          :to="{ name: 'ExchangeRequests' }"
          depressed
          color="secondary"
        ).ml-4 Заявки

      v-data-table(
        :headers="headers"
        :items="courses"
        :server-items-length="totalCourses"
        :page.sync="filters.page"
        :items-per-page="getPerPageFilter"
        :loading="loading"
        @update:items-per-page="setPerPageFilter"
      )
        template(v-slot:item.title="{ item }")
          router-link.font-weight-medium.body-1(
            :to="{ name: 'CourseDetails', params: { id: item.id }}"
          ) {{ item.title }}
        template(v-slot:item.status="{ item }")
          span {{ COURSE_EXCHANGE_STATUSES_NAMES[item.status] }}
        template(v-slot:item.price="{ item }")
          span {{ item.price }}
        template(v-slot:item.requests="{ item }")
          span {{ item.requests }}
        template(v-slot:item.purchases="{ item }")
          span {{ item.purchases }}
        template(v-slot:item.rating="{ item }")
          v-rating(
            :value="Math.round(item.rating/100*5)"
            :length="5"
            background-color="purple lighten-3"
            half-increments
            readonly
            dense
          )
        template(v-slot:item.actions="{ item }")
          v-menu(
            depressed
            nudge-bottom="10"
            transition="slide-y-transition"
            offset-y
            bottom
            left
          )
            template(v-slot:activator="{ on }")
              v-btn.mr-1.my-1(v-on="on" color="secondary" depressed small rounded)
                v-icon(left small) mdi-cog
                | Изменить
            v-list(rounded)
              v-list-item(
                @click="openSendToExchangeDialog(item.id)"
              )
                v-list-item-title
                  v-icon.mr-4 mdi-file-document-edit-outline
                  | Изменить цену
              v-list-item(
                @click="toggleStatusConfirmation = item"
              )
                v-list-item-title
                  v-icon.mr-4 mdi-folder-edit-outline
                  | {{ item.status !== 1 ? 'Активировать' : 'Деактивировать' }} курс
              v-list-item(
                @click="openDeleteDialog(item.id)"
              )
                v-list-item-title
                  v-icon.mr-4 mdi-delete
                  | Удалить курс с биржи

    confirm-dialog(
      v-slot:body
      :value="!!toggleStatusConfirmation"
      :loading="confirmationLoading"
      @confirm="toggleCourseStatus"
      @input="toggleStatusConfirmation = null"
    )
      span {{ toggleStatusMessage }}

    delete-dialog(
      v-model="showDeleteDialog"
      :request="$api.exchange.deleteOwnSellingCourse"
      :request-id="deleteId"
      @delete="onDelete"
    )
      template(v-slot:body) Вы действительно хотите удалить данный курс с биржи?

    send-to-exchange-dialog(
      v-model="showSendToExchangeDialog"
      :course="courseToExchange"
      @price:update="getOwnSellingCoursesList()"
    )

</template>

<script>
import { mapGetters } from 'vuex';
import SendToExchangeDialog from '@/modules/CourseManagement/components/SendToExchangeDialog.vue';
import { COURSE_EXCHANGE_STATUSES_NAMES } from '@/utils/constants';

export default {
  name: 'CourseList',
  components: {
    SendToExchangeDialog,
  },
  props: {
    /**
     * Название страницы
     */
    title: { type: String, default: 'Мои курсы на бирже' },
    /**
     * Переданные параметры для GET-запроса
     */
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    headers: [
      { text: 'Название', value: 'title' },
      { text: 'Статус', value: 'status' },
      { text: 'Цена, р.', value: 'price' },
      { text: 'Заявок, шт.', value: 'requests' },
      { text: 'Покупок, шт.', value: 'purchases' },
      { text: 'Рейтинг', value: 'rating' },
      { text: 'Действия', value: 'actions' },
    ],
    totalCourses: null,
    filters: {
      page: 1,
      'per-page': 15,
    },
    courses: [],
    deleteId: null,
    showSendToExchangeDialog: false,
    courseToExchange: {},
    showDeleteDialog: false,
    toggleStatusConfirmation: null,
    confirmationLoading: false,
    loading: false,
    COURSE_EXCHANGE_STATUSES_NAMES,
  }),
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
    getPerPageFilter() {
      if (this.filters['per-page'] === this.totalCourses) {
        return -1;
      }
      return this.filters['per-page'];
    },
    toggleStatusMessage() {
      if (this.toggleStatusConfirmation?.status !== 1) {
        return 'Курс будет активирован. Продолжить?';
      }
      return 'Курс будет деактивирован. Продолжить?';
    },
  },
  mounted() {
    this.getOwnSellingCoursesList();
  },
  methods: {
    /**
     * Устанавливает параметр per-page в GET-запросе для серверной пагинации
     * в зависимости от числа переданного компонентом v-data-table
     *
     * @param {Number} amount - Количество отображаемых элементов на странице
     */
    setPerPageFilter(amount) {
      if (amount === -1) {
        this.filters['per-page'] = this.totalCourses;
      } else {
        this.filters['per-page'] = amount;
      }
    },
    /**
     * Вызывается для получения списка собственных курсов с биржи
     *
     * @param {Object} params - Объект с параметрами для GET-запроса
     */
    getOwnSellingCoursesList(params = {}) {
      this.loading = true;
      params['search[owner_id]'] = this.userData.id;
      this.$rHandler(
        this.$api.exchange.getOwnSellingCoursesList(params),
        (r) => {
          this.courses = r.data.data;
          if (!this.totalCourses) {
            this.totalCourses = Number(r.headers['x-pagination-total-count']);
          }
          this.loading = false;
        },
      );
    },
    /**
     * Вызывается для открытия диалога где можно изменить цену размещенного курса
     *
     * @param {Number} courseId - id выбранного курса
     */
    openSendToExchangeDialog(courseId) {
      const selectedCourse = this.courses.find((course) => (
        course.id === courseId
      ));
      this.courseToExchange = selectedCourse;
      this.showSendToExchangeDialog = true;
    },
    /**
     * Вызывается для активирования/деактивирования курса
     */
    async toggleCourseStatus() {
      this.confirmationLoading = true;
      if (this.toggleStatusConfirmation.status !== 1) {
        await this.$rHandler(
          this.$api.exchange.activateOwnSellingCourse(this.toggleStatusConfirmation.id),
          (r) => {
            this.$toasted.success('Курс успешно активирован', { duration: 3000 });
            this.toggleStatusConfirmation = null;
            this.getOwnSellingCoursesList();
            return r;
          },
        );
      } else {
        await this.$rHandler(
          this.$api.exchange.deactivateOwnSellingCourse(this.toggleStatusConfirmation.id),
          (r) => {
            this.$toasted.success('Курс успешно деактивирован', { duration: 3000 });
            this.toggleStatusConfirmation = null;
            this.getOwnSellingCoursesList();
            return r;
          },
        );
      }
      this.confirmationLoading = false;
    },
    /**
     * Вызывается для открытия диалога на удаление курса с биржи
     */
    openDeleteDialog(courseId) {
      this.deleteId = courseId;
      this.showDeleteDialog = true;
    },
    /**
     * Вызывается после удаления курса с биржи
     */
    onDelete(id) {
      this.courses = this.courses.filter((c) => c.id !== id);
    },
  },
};
</script>
